import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate"
import SecureLS from "secure-ls";
import ConfigService from "../services/ConfigService";
var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex)

const defaultState = {
        employees: [],
        userRole: {},
}

export const store = new Vuex.Store( {

    plugins: [
        createPersistedState({
            storage: {
              getItem: (key) => ls.get(key),
              setItem: (key, value) => ls.set(key, value),
              removeItem: (key) => ls.remove(key),
            },
          }),
    ],

    state: defaultState,

    actions: {
        loadUserRole({commit, state}) {
            //todo: user endpoint
            axios.get(ConfigService.getApiUrl() + `/api/request/user`)
                    .then((response) => {
                        commit('SET_USER', response.data)
                    })
        },

        resetState({commit}) {            
            commit('RESET_STATE')
        }
      },

      mutations: {
        SET_USER(state, user) {
            state.userRole = user
        },
        RESET_STATE(state) {
            Object.assign(state, defaultState)
        }
      },
    
} )